import React, { PureComponent } from 'react';
import { GenericInputValidate } from 'com-gyf-webcore-userinterfacecomponents';

class CantidadCuotas extends PureComponent {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    onChange(e) {
        //TODO  queda pendiente si este control necesita algun comportamiento
        // this.props.actions.changeCuotas(event.target.value);
    }

    ValidateImporte(rule, value, callback) {
        if (value == undefined || value == "") {
            callback();
        }
        else {
            if (isNaN(value)) {
                callback('Debe ingresar un valor numérico.');
            }
            else {
                if (value > 0 && value < 255) {
                    callback();
                }
                else {
                    callback('Debe ingresar un numero entre 1 y 255.');
                }
            }
        }
    }

    render() {
        const me = this;
        const { ingresoAjuste, form } = this.props;
        const { getFieldProps, getFieldError } = form;
        let errors;
        let errorContainer = <label className="error">
            {(errors = getFieldError('inputCuotas')) ? errors.join(',') : null}</label>

        let error = ((getFieldError('inputCuotas')) ? true : false);
        let inhabilitarInput = ingresoAjuste.ajusteCargoRdButton ? true : false;
        return (
            <div className="row top-separator-xs">
                <div className="col-xs-5">
                    <label className="label-primary">Cantidad de Cuotas *</label>
                    <GenericInputValidate
                        // getFieldProps={getFieldProps('inputCuotas', {
                        //     onChange(e) {
                        //         me.onChange(e);
                        //     },
                        //     rules: [{
                        //         required: true,
                        //         message: 'Ingrese cuotas entre 1 y 255.',
                        //     }, {
                        //         validator: this.ValidateCuotas
                        //     }]
                        // })}
                        id="inputCantCuotas"
                        name="inputCantCuotas"
                        value={1}
                        className="form-control default-input"
                        maxLength="100"
                        autoComplete="off"
                        disabled={true}
                    />
                    {error && errorContainer}
                </div>
            </div>
        );
    }
}

export default CantidadCuotas;